import Geocode from 'react-geocode';

import { getIsoCodeCurrentLocale } from 'common/utils/helpers/multiregion';

import {
    FETCH_GEOCODE_POINT,
    FETCH_GEOCODE_POINT_FAILURE,
    FETCH_GEOCODE_POINT_SUCCESS,
} from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default (lat, lng) => (dispatch) => {
    Geocode.setApiKey(import.meta.env.VITE_GOOGLE_MAPS_KEY);
    Geocode.setLanguage(getIsoCodeCurrentLocale());
    Geocode.setRegion('mx');

    dispatch(companyGeneralActions[FETCH_GEOCODE_POINT]());

    return Geocode.fromLatLng(lat, lng).then(
        (response) => {
            dispatch(
                companyGeneralActions[FETCH_GEOCODE_POINT_SUCCESS](
                    response.results[0].formatted_address,
                ),
            );
        },
        (error) =>
            dispatch(
                companyGeneralActions[FETCH_GEOCODE_POINT_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
    );
};
